import React from 'react';
import { CheckCircle } from 'lucide-react';

const Services = ({ handleNavClick, isPreview }) => {
  const servicesData = [
    {
      title: 'Roofing',
      shortDesc: 'Expert roofing installation, replacement, and repair with premium materials and proven techniques for long-lasting protection.',
      fullDesc: 'Expert roofing services including installation, replacement, and repair. We work with all types of roofing materials and ensure your home is protected with quality workmanship backed by our 6-year warranty.',
      features: isPreview 
        ? ['Roof Installation', 'Roof Repairs', 'Roof Replacement']
        : ['Asphalt Shingles', 'Rubber Roofing', 'Metal Roofing', 'Complete Roof Installation', 'Roof Repairs & Maintenance', 'Roof Replacement', 'Emergency Repairs', 'Owens Corning Preferred Contractor']
    },
    {
      title: 'Siding',
      shortDesc: 'Professional siding installation and repair to protect and beautify your home with durable, weather-resistant materials.',
      fullDesc: 'Professional siding installation and repair services to protect and enhance your home\'s exterior. We offer a variety of siding materials and styles to match your preferences and budget.',
      features: isPreview 
        ? ['Vinyl Siding', 'Fiber Cement', 'Siding Repair']
        : ['Vinyl Siding Installation', 'Fiber Cement Siding', 'Siding Repair', 'Color Matching', 'Insulated Siding']
    },
    {
      title: 'Windows',
      shortDesc: 'Energy-efficient window installation and replacement to improve comfort and reduce energy costs.',
      fullDesc: 'Energy-efficient window installation and replacement services. Improve your home\'s comfort, reduce energy costs, and enhance curb appeal with new windows professionally installed.',
      features: isPreview 
        ? ['Window Installation', 'Window Replacement', 'Energy Efficient']
        : ['Window Installation', 'Window Replacement', 'Energy Efficient Options', 'Custom Sizes', 'Professional Sealing']
    },
    {
      title: 'General Carpentry',
      shortDesc: 'Skilled carpentry services for all your home improvement needs, from repairs to custom projects.',
      fullDesc: 'Skilled carpentry services for all your home improvement needs. From small repairs to major remodeling projects, our experienced carpenters deliver quality craftsmanship.',
      features: isPreview 
        ? ['Custom Work', 'Repairs', 'Remodeling']
        : ['Custom Carpentry Work', 'Deck Construction', 'Door Installation', 'Trim & Molding', 'Home Repairs', 'Additions', 'Garages', '3 Season Rooms']
    },
    {
      title: 'Plowing',
      shortDesc: 'Reliable snow plowing services to keep your property safe and accessible during winter months.',
      fullDesc: 'Dependable snow plowing services for residential and commercial properties. We keep your driveways, parking lots, and access roads clear and safe throughout the winter season.',
      features: isPreview 
        ? ['Residential Plowing', 'Commercial Plowing', 'Seasonal Contracts']
        : ['Residential Driveways', 'Commercial Lots', 'Seasonal Contracts', 'Per-Storm Service', '24/7 Availability']
    },
    {
      title: 'Snow Removal',
      shortDesc: 'Complete snow removal services including shoveling, salting, and ice management for safety.',
      fullDesc: 'Complete snow removal services including walkways, steps, and entrances. We provide salting and ice management to ensure safe access to your property during winter weather.',
      features: isPreview 
        ? ['Walkway Clearing', 'Ice Management', 'Salt Application']
        : ['Emergency Service', 'Roof Snow Removal', 'Walkway & Step Clearing', 'Ice Management', 'Salt & De-icer Application']
    }
  ];

  return (
    <section className="services" style={!isPreview ? { paddingTop: '4rem' } : {}}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{isPreview ? 'Our Services' : 'Services'}</h2>
          <p className="section-description">
            {isPreview 
              ? 'Home improvement and maintenance solutions'
              : 'Professional home improvement and maintenance services backed by our 6-year workmanship warranty'}
          </p>
        </div>
        <div className="services-grid">
          {servicesData.map((service, index) => (
            <div key={index} className="service-card">
              <h3>{service.title}</h3>
              <p>{isPreview ? service.shortDesc : service.fullDesc}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <CheckCircle size={18} /> {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;